<template>
    <div class="relative">
        <EmployeeEmploymentFields
            v-model:employee-tabel-code="employeeTabelCode"
            v-model:department="department"
            v-model:position="position"
            v-model:hired-date="date"
            v-model:fired-date="firedDate"
            v-model:percentage="percentage"
            v-model:shift-schedule="shiftSchedule"
            :departments="departmentStore.myDepartments"
            :positions="scheduleStore.positions"
            :shift-schedules="scheduleStore.shiftSchedules"
        />
        <div class="pt-3 text-right">
            <btn @click="save" :disabled="isDisabled" :class="{ 'opacity-50': isDisabled }">Сохранить</btn>
            <btn class="ml-3" type="secondary" @click="cancel">Отмена</btn>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useEmploymentStore } from '@/stores/employmentStore'
import { computed, ref } from 'vue'
import type { Option } from '@/types'
import dayjs from 'dayjs'
import EmployeeEmploymentFields from './EmployeeEmploymentFields.vue'
import { formatEmploymentDateForApi } from '@/utils/employmentDate'
const departmentStore = useDepartmentStore()
const scheduleStore = useScheduleStore()
const employmentStore = useEmploymentStore()
const emit = defineEmits(['created', 'cancel'])

const isSaving = ref(false)
const employeeTabelCode = ref('')
const percentage = ref(100 + '')
const position = ref<Option>({ id: '', name: 'Выберите должность'})
const department = ref<Option>({ id: '', name: 'Выберите подразделение'})
const shiftSchedule = ref<Option>({ id: '', name: 'Выберите расписание'})
const date = ref(dayjs())
const firedDate = ref()

const isDisabled = computed(() => {
    const hasValidPercentage = /^\d+$/.test(percentage.value) && Number(percentage.value) >= 0 && Number(percentage.value) <= 100
    const hasValidDateRange = Boolean(date.value) && (!firedDate.value || dayjs(date.value).isBefore(dayjs(firedDate.value)))

    return !(
        !isSaving.value &&
        department.value?.id &&
        position.value?.id &&
        shiftSchedule.value?.id &&
        hasValidPercentage &&
        hasValidDateRange
    )
})

const save = async () => {
    if (isDisabled.value) return
    isSaving.value = true
    try {
        let fired = formatEmploymentDateForApi(firedDate.value)
        const data: Record<string, string | number | null> = {
            department: department.value.id,
            position: position.value.id,
            percentage: +percentage.value/100,
            shift_schedule: shiftSchedule.value.id,
            hired_at: formatEmploymentDateForApi(date.value),
            fired_at: fired,
            user: employmentStore.user.id
        }
        if(employeeTabelCode.value) data.employee_tabel_code = employeeTabelCode.value
        const res = await employmentStore.createEmployment(data)
        if(res?.id) {
            await employmentStore.fetchUser(employmentStore.user.id)
            emit('created')
        }
    } finally {
        isSaving.value = false
    }
}

const cancel = () => {
    emit('cancel')
}
</script>
